(() => {
  const init = () => {
    if (!document.body || document.querySelector('[data-elfine-description-ready]')) return;
    const style = document.createElement('style');
    style.textContent = `
      .elfine-description-wrap { position: relative; }
      .elfine-description-wrap .elfine-description-content {
        position: relative;
        max-height: 240px;
        overflow: hidden;
        transition: max-height .35s ease;
      }
      .elfine-description-wrap:not(.is-expanded) .elfine-description-content::after {
        content: '';
        position: absolute;
        left: 0; right: 0; bottom: 0;
        height: 72px;
        pointer-events: none;
        background: linear-gradient(to bottom, rgba(255,255,255,0), var(--color-background, #fff) 88%);
      }
      .elfine-description-wrap.is-expanded .elfine-description-content { max-height: 5000px; }
      .elfine-description-toggle {
        width: 100%;
        margin-top: 10px;
        padding: 13px 0;
        border: 0;
        border-top: 1px solid rgba(40,32,24,.16);
        background: transparent;
        color: inherit;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 14px;
        font: inherit;
        font-weight: 600;
        cursor: pointer;
        text-align: left;
      }
      .elfine-description-toggle svg {
        width: 18px; height: 18px; flex: 0 0 18px;
        fill: none; stroke: currentColor; stroke-width: 1.7;
        transition: transform .25s ease;
      }
      .elfine-description-wrap.is-expanded .elfine-description-toggle svg { transform: rotate(180deg); }
      .elfine-description-toggle:focus-visible { outline: 2px solid currentColor; outline-offset: 3px; }
      @media (max-width: 749px) {
        .elfine-description-wrap .elfine-description-content { max-height: 205px; }
      }
    `;
    document.head.appendChild(style);

    const descriptions = [...document.querySelectorAll('.product-details .rte')];
    descriptions.forEach((description, index) => {
      if (description.closest('.elfine-description-wrap')) return;
      const textLength = (description.textContent || '').trim().length;
      if (textLength < 420 && description.scrollHeight < 300) return;

      const wrap = document.createElement('div');
      wrap.className = 'elfine-description-wrap';
      wrap.setAttribute('data-elfine-description-ready', '');
      const content = document.createElement('div');
      content.className = 'elfine-description-content';
      content.id = `ElfineProductDescription-${index + 1}`;

      description.parentNode.insertBefore(wrap, description);
      wrap.appendChild(content);
      content.appendChild(description);

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'elfine-description-toggle';
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', content.id);
      button.innerHTML = `<span>Read more</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="m6 9 6 6 6-6"></path></svg>`;
      wrap.appendChild(button);

      button.addEventListener('click', () => {
        const expanded = wrap.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', String(expanded));
        button.querySelector('span').textContent = expanded ? 'Show less' : 'Read more';
      });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();